import React, { forwardRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
    Grid,
    Typography,
    Box,
    Card,
    CardContent,
    IconButton,
    Avatar,
    Button,
    Link,
    Dialog,
    Slide,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    TextField
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import { extractValue } from '../../utils';
import { addTestimonialRequest } from 'services/testimonial';
import TestimonialForm from 'components/testimonial/TestimonialForm';
import appUrls from 'appUrls';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2)
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1)
    }
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500]
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function TestimonialModal({ open, setOpen, initialValues, fetchData, studentId }) {
    //  const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const navigate = useNavigate();
    const handleSubmitTestimonial = async (values, { resetForm, setSubmitting }) => {
        setSubmitting(true);
        const payload = {
            studentCommentTo: extractValue(values.student, '_id'),
            comment: values.comment,
            reqTestimonialId: studentId ?? null
        };

        console.log(payload, 'payload');
        const response = await addTestimonialRequest(payload);
        // console.log('-> response', response);
        if (response.error === false) {
            resetForm();
            navigate(appUrls.TESTIMONIAL);
            handleClose();
        }
        fetchData();
        setSubmitting(false);
    };
    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted={false}
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                Write Testimonial
            </BootstrapDialogTitle>
            <DialogContent p="0">
                <Box
                    p={1}
                    pt={0}
                    style={{
                        // height: 500,
                        width: '400px'
                    }}
                >
                    <TestimonialForm initialValues={initialValues} handleSubmit={handleSubmitTestimonial} />
                </Box>
            </DialogContent>
            {/* <DialogActions>
            <Button onClick={handleClose}>Save</Button>
        </DialogActions> */}
        </Dialog>
    );
}

export default TestimonialModal;
